import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Icon } from "@mui/material";
import axios from "axios";

import { conf } from "./const";
import { useSearchParams } from "react-router-dom";
import { fetchData, getPermissionByToken } from "./js/main";

function Copyright(props) {
  return (
    <Typography variant="body2" align="center" {...props}>
      <Typography variant="div">
        {"Copyright © "}
        <Link
          component="a"
          target="_blank"
          color="inherit"
          href="https://library.cmu.ac.th"
        >
          CMUL Digital Payment
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignInSide() {
  const [searchParams /*, setSearchParams*/] = useSearchParams();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    (async () => {
      let ref = searchParams.get("ref");
      if (ref && ref !== "") {
        let token = await axios.get(conf.endpoint.auth + "/token/" + ref, {
          headers: { Authorization: conf.key.auth },
        });
        if (token && token.data && token.data.token) {
          token = token.data.token;
          let profile = await getPermissionByToken(token);
          if (profile && profile.usn)
            window.location = process.env.PUBLIC_URL + "/";
          else window.location = process.env.PUBLIC_URL + "/login";
        } else {
          window.location = process.env.PUBLIC_URL + "/login";
        }
      } else {
        let cookie = JSON.parse(localStorage.getItem(conf.cookieName));
        if (cookie && cookie.access_token) {
          window.location = process.env.PUBLIC_URL + "/";
        } else {
          await fetchData("delete", "/signout");
          localStorage.removeItem(conf.cookieName);
          setLoaded(true);
        }
      }
    })();
  }, [searchParams]);

  function goLogin() {
    axios
      .post(
        conf.endpoint.auth + "/login",
        { callback: conf.loginCallback },
        { headers: { Authorization: conf.key.auth } }
      )
      .then((res) => {
        window.location = res.data.login_url;
      });
  }
  return (
    <ThemeProvider theme={defaultTheme}>
      {loaded === true && (
        <Grid container component="main" sx={{ height: "100vh" }}>
          <CssBaseline />
          <Grid
            item
            xs={false}
            sm={4}
            md={7}
            sx={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/img/login.jpg)`,
              backgroundRepeat: "no-repeat",
              backgroundColor: (t) =>
                t.palette.mode === "light"
                  ? t.palette.grey[50]
                  : t.palette.grey[900],
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={6}
            square
          >
            <Box
              sx={{
                my: 8,
                mx: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h1 style={{ fontWeight: 500 }}>CMUL Digital Payment</h1>
              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign in
              </Typography>
              <Box
                component="form"
                noValidate
                sx={{ mt: 1, paddingTop: "30px" }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 3, mb: 2 }}
                  size="large"
                  startIcon={<Icon>key</Icon>}
                  onClick={goLogin}
                >
                  CMU Account Sign In
                </Button>
                <Copyright sx={{ mt: 5 }} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </ThemeProvider>
  );
}
